import React from 'react';
import PropTypes from 'prop-types';

import { BUTTON_TYPES } from 'helpers/TypeHelper';
import Icon from 'componentsV2/Icon';
import classNames from 'classnames';
import { urlIsExternal } from 'helpers/ContentHelper';
import { noop } from 'helpers/GlobalHelper';
import LinkButton from '../LinkButton';
import style from './Button.module.scss';

const Button = ({
  type,
  url,
  label,
  theme = {},
  toggled = false,
  primary = false,
  onClick = noop,
}) => {
  if (!label) return null;
  let icon = null;
  switch (type) {
    case BUTTON_TYPES.WATCH:
      icon = 'play';
      break;
    case BUTTON_TYPES.TRAILER:
      icon = 'trailer';
      break;
    case BUTTON_TYPES.RESTART:
      icon = 'restart';
      break;
    case BUTTON_TYPES.NOTIFICATION:
      icon = `bell-${toggled ? 'on' : 'off'}`;
      break;
    case BUTTON_TYPES.WATCHLIST:
      icon = `${toggled ? 'check' : 'plus'}`;
      break;
    case BUTTON_TYPES.PERSONALITY_FAVORITE:
      icon = `${toggled ? 'fav-on' : 'fav-off'}`;
      break;
    case BUTTON_TYPES.UPSELL:
      icon = 'upsell';
      break;
    case BUTTON_TYPES.MORE_DETAILS:
      break;
    default:
      break;
  }
  const buttonStyle = primary ? [style.primary, theme.primary] : [style.secondary, theme.secondary];
  const buttonLink = urlIsExternal(url) ? { href: url } : { to: url };

  return (
    <LinkButton
      key={label}
      className={classNames(style.button, theme.button, style[icon], buttonStyle)}
      onClick={onClick}
      {...buttonLink}
    >
      <div className={style.buttonContent}>
        <Icon className={classNames(style.buttonIcon, theme.buttonIcon)} icon={icon} />
        <span className={classNames(style.label, theme.label)}>{label}</span>
      </div>
    </LinkButton>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  primary: PropTypes.bool,
  theme: PropTypes.shape({}),
  toggled: PropTypes.bool,
  type: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
